<template>
  <div class="page-order page-content" v-loading="body_loading">
    <div class="main-body">
      <el-row class="hd">
        <el-col :span="24">
          <h3 style="float: none;">物业报修</h3>
          <div class="flex-block breadcrumb-box">
            <div class="position-text">位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>物业报修</el-breadcrumb-item>
              <el-breadcrumb-item>物业报修</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
      <div class="bd">
        <div class="search-block content-body">
          <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
            <el-form-item prop="userName" label="创建人姓名：" style="margin-bottom: 0;">
              <el-input v-model="form_search.userName" size="small" placeholder="请输入创建人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item prop="status" label="状态：" style="margin-bottom: 0;">
              <el-select v-model="form_search.status" size="small" placeholder="请选择状态" clearable>
                <el-option label="待确认" value="待确认"></el-option>
                <el-option label="待处理" value="待处理"></el-option>
                <el-option label="已处理" value="已处理"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;">
              <el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-block content-body">
          <div ref="contentBody">
            <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
              <el-table-column prop="buildingName" align="center" label="楼宇名称" min-width="120"/>
              <el-table-column prop="type" align="center" label="维修类型" min-width="120"/>
              <el-table-column prop="place" align="left" label="位置" min-width="160"/>
              <el-table-column prop="remark" align="left" label="简要描述" min-width="160"/>
              <el-table-column align="center" label="附件" min-width="120">
                <template slot-scope="scope">
                  <div class="media-list">
                    <div v-if="scope.row.imgIds" class="media-item" @click="previewImages(scope.row.imgIds, 0)">
                      <i class="el-icon-picture-outline"></i>
                      <span>图片({{ (scope.row.imgIds || '').split(',').filter(id => id).length }})</span>
                    </div>
                    <div v-if="scope.row.videoId" class="media-item" @click="previewVideo(scope.row.videoId)">
                      <i class="el-icon-video-camera"></i>
                      <span>视频</span>
                    </div>
                    <span v-if="!scope.row.imgIds && !scope.row.videoId" class="no-media">无</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="status" align="center" label="状态" min-width="100">
                <template slot-scope="scope">
                  <span :class="{'status-confirm': scope.row.status === '待确认', 'status-pending': scope.row.status === '待处理', 'status-completed': scope.row.status === '已处理'}">{{ scope.row.status }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createUserName" align="center" label="创建人" min-width="100"/>
              <el-table-column prop="createdate" align="center" label="创建时间" min-width="160"/>
              <el-table-column align="center" label="操作" min-width="180">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="confirmTask(scope.row)" :disabled="scope.row.status !== '待确认'">确认</el-button>
                  <el-button size="small" type="success" @click="handleTask(scope.row)" :disabled="scope.row.status !== '待处理'">处理</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]" :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next" :total="table_data.page_info.total"></el-pagination>
        </div>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="600px">
          <div class="preview-container">
            <el-image
              :src="dlg_preview.img_url"
              :preview-src-list="dlg_preview.preview_list"
              fit="contain"
              style="width:100%;">
            </el-image>
            <div class="preview-nav" v-if="dlg_preview.images.length > 1">
              <el-button @click="prevImage" :disabled="dlg_preview.current === 0" size="small">上一张</el-button>
              <span>{{ dlg_preview.current + 1 }} / {{ dlg_preview.images.length }}</span>
              <el-button @click="nextImage" :disabled="dlg_preview.current === dlg_preview.images.length - 1" size="small">下一张</el-button>
            </div>
          </div>
        </el-dialog>
        <el-dialog title="视频预览" :visible.sync="dlg_video.visible" width="800px">
          <video v-if="dlg_video.visible" :src="dlg_video.url" controls style="width:100%;max-height:500px;"></video>
        </el-dialog>
        <el-dialog title="处理报修" :visible.sync="dlg_handle.visible" width="534px" @close="closeHandle">
          <el-form ref="formHandle" :model="dlg_handle.form" label-width="100px" :rules="dlg_handle.rules">
            <el-form-item label="回复内容：" prop="replyContent">
              <el-input type="textarea" v-model="dlg_handle.form.replyContent" :rows="4" placeholder="请输入回复内容"></el-input>
            </el-form-item>
            <el-form-item label="回复图片：">
              <el-upload :action="dlg_handle.upload.action" :headers="dlg_handle.upload.headers" accept="image/*" list-type="picture-card" :file-list="dlg_handle.img_list" :on-success="uploadSuccess" :on-remove="removeImg" multiple>
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dlg_handle.visible = false">取 消</el-button>
            <el-button type="primary" @click="submitHandle" :loading="dlg_handle.btn_loading">确认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'propertyMaintenanceList',
  data() {
    return {
      clientHeight: '',
      baseUrl: this.$client.API_URL,
      body_loading: false,
      form_search: {
        status: '',
        userName: ''
      },
      table_data: {
        loading: false,
        list: [],
        page_info: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      },
      dlg_preview: {
        visible: false,
        img_url: '',
        images: [],
        preview_list: [],
        current: 0
      },
      dlg_video: {
        visible: false,
        url: ''
      },
      dlg_handle: {
        visible: false,
        btn_loading: false,
        form: {
          icode: '',
          replyContent: '',
          replyIds: ''
        },
        img_list: [],
        upload: {
          action: this.$client.API_URL + '/api/sys/file/upload',
          headers: {token: localStorage.getItem('token'), loginFrom: 'pc'}
        },
        rules: {
          replyContent: {required: true, message: '请输入回复内容', trigger: 'blur'}
        }
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    searchList() {
      this.table_data.page_info.page = 1;
      this.getList();
    },
    getList() {
      var _this = this;
      var params = _this.form_search;
      params.page = _this.table_data.page_info.page;
      params.pageSize = _this.table_data.page_info.pageSize;
      _this.table_data.loading = true;
      this.$client.get('/api/biz/property/maintenance/getListForAdmin', params, function(res, message, total) {
        _this.table_data.list = res;
        _this.table_data.page_info.total = total;
        _this.table_data.loading = false;
      }, function(res) {
        _this.table_data.loading = false;
      });
    },
    handleSizeChange(val) {
      this.table_data.page_info.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.table_data.page_info.page = val;
      this.getList();
    },
    previewImages(imgIds, index) {
      const ids = (imgIds || '').split(',').filter(id => id).map(id => id.trim());
      this.dlg_preview.images = ids;
      this.dlg_preview.current = index;
      this.dlg_preview.img_url = this.baseUrl + '/api/sys/file/download?attachId=' + ids[index];
      this.dlg_preview.preview_list = ids.map(id => this.baseUrl + '/api/sys/file/download?attachId=' + id);
      this.dlg_preview.visible = true;
    },
    prevImage() {
      if (this.dlg_preview.current > 0) {
        this.dlg_preview.current--;
        this.dlg_preview.img_url = this.baseUrl + '/api/sys/file/download?attachId=' + this.dlg_preview.images[this.dlg_preview.current];
      }
    },
    nextImage() {
      if (this.dlg_preview.current < this.dlg_preview.images.length - 1) {
        this.dlg_preview.current++;
        this.dlg_preview.img_url = this.baseUrl + '/api/sys/file/download?attachId=' + this.dlg_preview.images[this.dlg_preview.current];
      }
    },
    previewVideo(videoId) {
      this.dlg_video.url = this.baseUrl + '/api/sys/file/download?attachId=' + videoId;
      this.dlg_video.visible = true;
    },
    confirmTask(row) {
      this.$confirm('确认该报修任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = { icode: row.icode, status: '待处理' };
        this.$client.post('/api/biz/property/maintenance/save', params, () => {
          this.$message.success('操作成功');
          this.getList();
        });
      }).catch(() => {});
    },
    handleTask(row) {
      this.dlg_handle.visible = true;
      this.dlg_handle.form.icode = row.icode;
    },
    uploadSuccess(res, file, fileList) {
      this.dlg_handle.img_list = fileList;
    },
    removeImg(file, fileList) {
      this.dlg_handle.img_list = fileList;
    },
    submitHandle() {
      var _this = this;
      _this.$refs['formHandle'].validate((valid) => {
        if (valid) {
          var replyIds = _this.dlg_handle.img_list.map(item => item.response ? item.response.data.icode : item.icode).filter(id => id).join(',');
          var params = {
            icode: _this.dlg_handle.form.icode,
            replyContent: _this.dlg_handle.form.replyContent,
            replyIds: replyIds,
            status: '已处理'
          };
          _this.dlg_handle.btn_loading = true;
          _this.$client.post('/api/biz/property/maintenance/save', params, function(res, message) {
            _this.$message.success('操作成功');
            _this.getList();
            _this.dlg_handle.btn_loading = false;
            _this.dlg_handle.visible = false;
          }, function() {
            _this.dlg_handle.btn_loading = false;
          });
        }
      });
    },
    closeHandle() {
      this.dlg_handle.form.replyContent = '';
      this.dlg_handle.form.replyIds = '';
      this.dlg_handle.img_list = [];
      this.$refs.formHandle.clearValidate();
    }
  },
  mounted() {
    this.clientHeight = `${document.documentElement.clientHeight}`;
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    clientHeight: function() {
      if (this.$refs.contentBody) {
        this.$refs.contentBody.style.minHeight = (this.clientHeight - 394) + 'px';
      }
    }
  }
}
</script>
<style scoped>
.media-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}
.preview-container {
  text-align: center;
}
.preview-nav {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}
.media-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: #f0f9ff;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  color: #409EFF;
  font-size: 13px;
}
.media-item:hover {
  background: #409EFF;
  color: white;
}
.media-item i {
  font-size: 16px;
}
.no-media {
  color: #999;
  font-size: 13px;
}
.status-confirm {
  color: #909399;
  font-weight: bold;
}
.status-pending {
  color: #E6A23C;
  font-weight: bold;
}
.status-completed {
  color: #67C23A;
  font-weight: bold;
}
</style>
